(ns frontend.ui.component.lp-portal.report.body.private-equity.holding.credit-company.pdf
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.stacked-text-group.pdf.view :as stacked-text-group]
   [clojure.string :as string]
   [frontend.ui.page.lp-portal.report.pdf.view :as report]))


(defn- latest-development-figures-board
  [board]
  (let [[section-title board-members] (:figures board)]
    (card/card
     section-title
     (map (fn [board-member]
            (let [[member-name & member-title-strs] (string/split board-member ", ")]
              {:stack  [member-name
                        {:text  (string/join ", " member-title-strs)
                         :color (theme/color [:text :secondary :color])}]
               :margin [0 0 0 15]}))
          board-members))))

(defn overview-pages
  [report-data]

  [(page/page
    (page/third-column-background)
    (page/page-title {:page-title (:holding-name report-data) :toc-item true})
    (column/columns-2-to-1
     {:stack [(card/card
               "Case Overview"
               (text-content/rich-content (->> report-data
                                               :overview
                                               :case-overview-text
                                               :rich-content)))
              #_(card/card
                 "Value Creation Plan & Exit Vision"
                 (text-content/rich-content (->> report-data
                                                 :overview
                                                 :value-creation-plan-text
                                                 :rich-content)))
              (card/card
               "Latest Development"
               (text-content/rich-content (->> report-data
                                               :overview
                                               :latest-development-text
                                               :rich-content)))]}
     {:margin [0 15 0 0]
      :stack  (->> report-data
                   :overview
                   :overview-figures
                   :figures
                   (map
                    (fn [[label value]]
                      (stacked-text-group/stacked-text-group label value))))}))
   #_(page/page
      (page/third-column-background)
      (page/page-title {:page-title (:holding-name report-data)})
      (column/columns-2-to-1
       (card/card "Value Creation Plan & Exit Vision"
                  (text-content/rich-content (->> report-data
                                                  :overview
                                                  :value-creation-plan-text
                                                  :rich-content)))
       (latest-development-figures-board (-> report-data
                                             :overview
                                             :board))))])


(defn holding-pages
  "PDFMake page definitions for Private Equity holding Company to be passed to
  `frontend.ui.page.lp-portal.report.pdf.view/report` in production. See `company-pages`."
  [{:keys [holding-name
           reference-date
           report-id
           overview
           optional-section]
    :as   report-data}]
  (overview-pages report-data))

(defn company
  "View for a LP Portal report that is solely based on Private Equity holding Company (no fund).
  This function will likely only be used by a Devcard for showcase purposes. See `company-pages`."
  [{:keys [reporting-period reference-date] :as view-data}]
  (report/report view-data
                 (holding-pages view-data)
                 "PE holding company"
                 reporting-period
                 reference-date))
